import React from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBContainer,
  MDBDataTable,
  MDBCol,
  MDBRow,
} from "mdbreact";
import { CMDBBtn } from "../StyledComponent";
import "../../../assets/css/fonts.css";
import SectionContainer from "../sectionContainer";

const SellerCategoryView = (props) => {
  return (
    <MDBContainer
      style={{
        minWidth: "1000px",
        paddingTop: "6rem",
        fontFamily: "Lato Semi Bold",
      }}
    >
      <SectionContainer header={`Manage Product Category`}>
        <MDBCard style={{ fontFamily: "Lato Regular" }}>
          <MDBRow>
            <MDBCol>
              <CMDBBtn
                active
                bg_color={props.seller_style.color_btn}
                onClick={() => props.addModal("ADD")}
              >
                Tambah Kategori
              </CMDBBtn>
            </MDBCol>
            <MDBCol />
          </MDBRow>
          <MDBCardBody>
            <MDBDataTable hover noBottomColumns responsive data={props.data} />
          </MDBCardBody>
        </MDBCard>
      </SectionContainer>
    </MDBContainer>
  );
};

export default SellerCategoryView;
